import api from "./api";

export const authService = {
  async login(email, password) {
    const res = await api.post("/auth/login", { email, password });
    const { token, user } = res.data;
    localStorage.setItem("token", token);
    return { token, user };
  },

  async signup(email, password, passwordConfirm) {
    const res = await api.post("/auth/signup", {
      email,
      password,
      passwordConfirm,
    });
    // Only save token if present (for future, but not used now)
    const { token, user, message } = res.data;
    if (token) localStorage.setItem("token", token);
    return { user, message };
  },

  async logout() {
    const token = localStorage.getItem("token");
    if (token) {
      await api.post("/auth/logout");
    }
    localStorage.removeItem("token");
  },

  async getCurrentUser() {
    const token = localStorage.getItem("token");
    if (!token) return null;

    const res = await api.get("/auth/me");
    return { user: res.data.user, token };
  },

  async resendVerificationEmail(email) {
    return api.post("/auth/send-verification-email", { email });
  },
};

export const adminAPI = {
  getAllUsers: () => api.get("/auth/all-users"),
  changeUserRole: (userId, role) =>
    api.put(`/auth/users/${userId}/role`, { role }),
  blockUser: (userId, blocked) =>
    api.put(`/auth/users/${userId}/block`, { blocked }),
  toggleUserStatus: (userId) =>
    api.put(`/auth/users/${userId}/status`),
  deleteUser: (userId) => api.delete(`/auth/users/${userId}`),
  sendVerificationEmail: (userId) => 
    api.post(`/auth/admin/send-verification/${userId}`),
  checkVerificationCooldown: (userId) => 
    api.get(`/auth/verification-cooldown/${userId}`),
};

export default authService;
